import { render, staticRenderFns } from "./ClinicDetails.vue?vue&type=template&id=741e77f8&"
import script from "./ClinicDetails.vue?vue&type=script&lang=js&"
export * from "./ClinicDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports